// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"20":"48292e9a","27":"d7d90746","360":"557f1bbf","560":"a0458be3","669":"a903fa2d","810":"859d6356","858":"a358ddaf","935":"601d2594","981":"d385757f"}[chunkId] + ".css";
};